import { track } from './analyticsAdapterClient';

const gameClickBaseEventData = {
    GameCategory: 'Gaming/Sports/Unknown/Unknown/Unknown',
    GameClassName: 'NA',
    GameSupplier: 'NA',
    GameTypeName: 'NA',
    ProductName: 'Sports',
    SubProductName: 'NA',
};

/**
 * Verify if triggered from bottom navigation
 *
 * @param {string} val
 * @return boolean
 */
const isBottomNav = val => val === 'footer-nav';

/**
 * Use adapter client to register bottom navigation tracking event
 *
 * @param {object}
 * @return void
 */
const sendBottomNavTrackingEvent = ({
    EventLabel,
    GameCode,
    GameListPosition,
    GameName,
}) => {
    const payload = Object.assign({
        EventLabel,
        GameCode,
        GameList: 'Bottom Nav',
        GameListPosition,
        GameName,
    }, gameClickBaseEventData);

    track({ event: 'game_click', payload });
};

/**
 * Send game click tracking event
 *
 * @param {object}
 * @return void
 */
export const doGameClickTracking = ({
    EventLabel,
    GameCode,
    GameList,
    GameListPosition,
    GameName,
}) => {
    if (isBottomNav(GameList)) {
        sendBottomNavTrackingEvent({
            EventLabel: EventLabel || 'NA',
            GameCode: GameCode || 'NA',
            GameListPosition: GameListPosition || 'NA',
            GameName: GameName || 'NA',
        });
    }
};
